﻿export default function (value) {
    const words = ['лет', 'год', 'года', 'года', 'года', 'лет', 'лет', 'лет', 'лет', 'лет'];
    const lastDigits = value % 100;
    if (lastDigits > 10 && lastDigits < 20) {
        return Math.trunc(value) + ' лет';
    }
    else {
        return Math.trunc(value) + " " + words[value % 10];
    }
}
